














import { Vue, Component, Prop } from "vue-property-decorator";

import { BaseModal } from "@/components/organisms/Modal/BaseModal";

import Confirm from "@/components/organisms/Modal/OrderFast/Confirm.vue";
import Success from "@/components/organisms/Modal/OrderFast/Success.vue";

import { IOrderItem } from "@/services/interfaces/requests";
import { IGenericResponse } from "@/services/interfaces";

@Component({
  components: { BaseModal, Success, Confirm },
})
export default class OrderModal extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly order!: IOrderItem[];

  @Prop({ type: Function, default: () => null })
  readonly orderSend!: (comment: string) => Promise<IGenericResponse>;

  loading = false;
  successCreated = false;
  error = "";

  async sendHandler(comment: string) {
    this.loading = true;
    try {
      const res = await this.orderSend(comment);
      this.successCreated = res.status === 201;
      if (res.errors) {
        this.error = Object.values(res.errors as object)[0][0];
      }
    } catch (err) {
      console.warn(err); // eslint-disable-line no-console
    } finally {
      this.loading = false;
    }
  }
}
